import React from "react";
import { Box, Avatar, Typography, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const SectionHeader = ({ icon, title, color, onRefresh, refreshing, children }) => (
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} mt={1}>
        <Box display="flex" alignItems="center" gap={1}>
            <Avatar
                sx={{
                    width: 32,
                    height: 32,
                    background: color.gradient,
                    boxShadow: `0 4px 12px ${color.main}30`,
                }}
            >
                {icon}
            </Avatar>
            <Typography
                variant="h6"
                fontWeight={700}
                fontFamily="Montserrat, sans-serif"
                sx={{ color: "#1a1a2e" }}
            >
                {title}
            </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
            {children}
            {onRefresh && (
                <Tooltip title="Rafraîchir">
                    <IconButton
                        size="small"
                        onClick={onRefresh}
                        sx={{ color: color.main, "&:hover": { bgcolor: color.light } }}
                    >
                        <RefreshIcon
                            fontSize="small"
                            sx={{
                                animation: refreshing ? "spin 1s linear infinite" : "none",
                                "@keyframes spin": {
                                    "0%": { transform: "rotate(0deg)" },
                                    "100%": { transform: "rotate(360deg)" },
                                },
                            }}
                        />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    </Box>
);

export default SectionHeader;
